import {Component, OnInit, ViewChild} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Router} from '@angular/router';
import Env from '../../../env/env';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';

export interface DataColumns {
  columns: string[];
}

export interface SearchData {
  results: string[][];
}

export class NeighborsConfig {
  mode = 'keywords';
  isTimelineCase = true;
  sameArtist = true;
  sameMedium = true;
  sameArtworkName = false;
  sameSize = false;
  sameEditionRank = false;
  similarMediums = false;
  sameMovement = false;
  artworkDateWindow5 = false;
  artworkDateInTimelineMovement = false;
  sameNationality = false;
  sameGeneration = false;
}

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})
export class SearchComponent implements OnInit {
  searchTerm: string;
  enableRegex = false;
  columns: string[];
  displayedColumns: string[];
  hasSelectedItems = false;

  @ViewChild('searchPaginator', {static: true}) searchPaginator: MatPaginator;
  @ViewChild('searchSort', {static: true}) searchSort: MatSort;
  dataSource: MatTableDataSource<string[]>;

  selectedRowSource: MatTableDataSource<string[]>;
  @ViewChild('selectedSort', {static: true}) selectedSort: MatSort;
  @ViewChild('selectedPaginator', {static: true}) selectedPaginator: MatPaginator;

  // Neighbors options
  neighborThreshold: number[] = Array.from(Array(18).keys()).map(x => x + 3);
  selectedNeighborThreshold = 3;

  cases: string[] = Env.searchCases;
  selectedCase = '20';
  modes: string[] = [ 'keywords', 'styles' ];
  neighborsConfig: NeighborsConfig = new NeighborsConfig();

  constructor(private http: HttpClient, private router: Router) { }

  ngOnInit() {
    this.http.get<DataColumns>(Env.apiUrl + '/data/columns').subscribe((data) => {
      this.columns = data.columns;
      this.displayedColumns = [...Array(this.columns.length).keys()].map(x => x.toString());
      this.displayedColumns.unshift('control');

      this.dataSource = new MatTableDataSource();
      this.dataSource.paginator = this.searchPaginator;
      this.dataSource.sort = this.searchSort;

      this.selectedRowSource = new MatTableDataSource();
      this.selectedRowSource.paginator = this.selectedPaginator;
      this.selectedRowSource.sort = this.selectedSort;
    });
  }

  search() {
    if (!this.searchTerm) {
      return;
    }

    document.getElementById('search-icon').style.display = 'none';
    document.getElementById('search-spinner').style.display = 'inline-block';
    document.getElementById('search-button').setAttribute('disabled', 'disabled');

    let params = new HttpParams();
    params = params.append('term', this.searchTerm);
    if (this.enableRegex) {
      params = params.append('regex', 'true');
    }

    this.http.get<SearchData>(Env.apiUrl + '/data/search', { params }).subscribe((newData) => {
      this.dataSource.data = newData.results;

      document.getElementById('search-icon').style.display = 'inline-block';
      document.getElementById('search-spinner').style.display = 'none';
      document.getElementById('search-button').removeAttribute('disabled');
    });
  }

  renderRow(row: string[], id: string) {
    if (row[id] && (row[id].startsWith('http://') || row[id].startsWith('https://'))) {
      return `<a href="${row[id]}" target="_blank">${row[id]}</a>`;
    }
    return row[id];
  }

  isSelected(rowId: string): boolean {
    return this.selectedRowSource.data.some(r => r[this.getIdColumn()] === rowId);
  }

  selectRow(row: string[]) {
    document.getElementById('add-' + row[this.getIdColumn()]).setAttribute('disabled', 'disabled');
    this.selectedRowSource.data = this.selectedRowSource.data.concat([row]);
    this.hasSelectedItems = true;
  }

  unselectRow(row: string[]) {
    if (document.getElementById('add-' + row[this.getIdColumn()])) {
      document.getElementById('add-' + row[this.getIdColumn()]).removeAttribute('disabled');
    }
    this.selectedRowSource.data = this.selectedRowSource.data.filter(r => r !== row);
    this.hasSelectedItems = this.selectedRowSource.data.length > 0;
  }

  goToProcessPage() {
    this.router.navigate([ '/estimate' ], {
      queryParams: {
        id: this.selectedRowSource.data.map((row) => row[this.columns.indexOf('line_number')])
      }
    });
  }

  goToNeighborsPage() {
    let params: any = {
      id: this.selectedRowSource.data.map(row => row[this.columns.indexOf('line_number')]),
      nt: this.selectedNeighborThreshold,
      case: this.selectedCase
    };
    if (params.case === 'CUSTOM') {
      params = {
        ...this.neighborsConfig,
        ...params
      };
    }

    this.router.navigate(['/neighbors'], {
      queryParams: params
    });
  }

  getIdColumn(): number {
    return this.columns.indexOf('line_number');
  }
}
